import { apiRequest } from './client';

// Admin only: customer, staff and administrator accounts (see /api/admin/users).

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => { if (value) search.set(key, value); });
  return search.toString();
};

/** { role: 'User' | 'Staff' | 'Admin' | '', search, page, pageSize } → { users, page, pageSize, totalCount } */
export const adminListUsers = (token, params) => apiRequest(`/api/admin/users?${query(params)}`, { token });

/** [{ key, label, description }] — the screens a staff account can be given. */
export const adminListPermissions = (token) => apiRequest('/api/admin/permissions', { token });

/** account: { email, firstName, lastName, password, role, permissions } */
export const adminCreateUser = (token, account) => apiRequest('/api/admin/users', { body: account, token });

export const adminSetAccess = (token, id, role, permissions) =>
  apiRequest(`/api/admin/users/${id}/access`, { method: 'PUT', body: { role, permissions }, token });

export const adminSetPassword = (token, id, password) =>
  apiRequest(`/api/admin/users/${id}/password`, { body: { password }, token });

export const adminSetActive = (token, id, isActive) =>
  apiRequest(`/api/admin/users/${id}/status`, { method: 'PATCH', body: { isActive }, token });
